import styled from "styled-components";
import AppLayout from "./components/AppLayout";
import GlobalStyles from "./styles/GlobalStyle.js";
import { Toaster } from "react-hot-toast";

const MainDiv = styled.div`
  background-image: url("/MondCup-Slider.png");
  background-size: cover; /* یا contain بسته به هدف شما */
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh; /* تا حداقل به اندازه تمام صفحه باشد */
  color: var(--color-grey-100);
`;

function App() {
  return (
    <div>
      <GlobalStyles />
      <MainDiv>
        <AppLayout />
      </MainDiv>

      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 5000,
          },
          style: {
            fontSize: "16px",
            maxWidth: "500px",
            padding: "16px 24px",
            backgroundColor: "var(--color-grey-0)",
            color: "var(--color-grey-700)",
          },
        }}
      />
    </div>
  );
}

export default App;
